import { VillageType } from './appTypes'
import { constants } from './constants'
import { getConnectUser } from './getConnectUser'

export type OpenedVillageZone = {
    zoneName?: string | null
    zoneSFID?: string | null
    zone_code?: string | null
}

export const buildOpenedVillageRecord = (village: VillageType) => ({
    sf_id: village.sf_id,
    name: village.name || '',
    code: village.code || ''
})

export const setOpenedVillageSession = (
    village: VillageType,
    zone: OpenedVillageZone = {}
) => {
    const current = getConnectUser() as ReturnType<typeof getConnectUser> & {
        zone_code?: string
    }
    const standaloneVillages = [buildOpenedVillageRecord(village)]
    localStorage.setItem(
        constants.CONNECT_USER,
        JSON.stringify({
            ...current,
            veVillages: standaloneVillages,
            veCode: undefined,
            zoneName: zone.zoneName || current.zoneName,
            zoneSFID: village.zone_sfid || zone.zoneSFID || current.zoneSFID,
            zone_code:
                village.zone_code ||
                zone.zone_code ||
                current.zone_code ||
                current.zoneCode
        })
    )
    return standaloneVillages
}
